<script setup lang="ts">
import { computed } from 'vue';
import type { PropType } from 'vue';
import gettext from '@/i18n/gettext';
import type { CatalogueItemGroup } from '@/models/Catalogue';
import { useCatalogueGroupAutocomplete } from '@/composables/catalogue/useCatalogueGroupAutocomplete';

const { $gettext } = gettext;

defineOptions({ inheritAttrs: false });

const props = defineProps({
  modelValue: {
    type: String as PropType<string | null>,
    default: null,
  },
  groups: {
    type: Array as PropType<CatalogueItemGroup[]>,
    required: true,
  },
  label: {
    type: String,
    default: undefined,
  },
  rules: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    type: Array as PropType<any[]>,
    default: undefined,
  },
  required: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits<{
  (e: 'update:modelValue', value: string | null): void;
}>();

const { autocompleteOptions } = useCatalogueGroupAutocomplete(
  computed(() => props.groups),
);

const valueModel = computed({
  get: () => props.modelValue,
  set: (val: string | null) => emit('update:modelValue', val),
});
</script>

<template>
  <v-autocomplete
    v-model="valueModel"
    :items="autocompleteOptions"
    item-title="title"
    item-value="value"
    :label="label || $gettext('Group')"
    :rules="rules"
    :required="required"
    hide-details
    v-bind="$attrs"
  >
    <template #item="{ props: itemProps, item }">
      <v-list-item v-bind="itemProps">
        <v-list-item-subtitle>
          {{ item.raw.path }}
        </v-list-item-subtitle>
      </v-list-item>
    </template>
  </v-autocomplete>
</template>
